export default [
  {
    path: '/v2/service-process/order',
    name: '订单中心',
    component: () => import ( /* webpackChunkName: "table" */ `@/views/v2/service-process/order/index.vue`),
    meta: {
      permission: ['wage_order']
    }
  },
  {
    path: '/v2/service-process/order/detail',
    name: '订单详情',
    component: () => import ( /* webpackChunkName: "table" */ `@/views/v2/service-process/order/detail.vue`),
    meta: {
      permission: ['wage_order']
    }
  },
  {
    path: '/v2/service-process/bill',
    name: '账单列表',
    component: () => import ( /* webpackChunkName: "table" */ `@/views/v2/service-process/bill/index.vue`),
    meta: {
      permission: ['set_fwlc_bill_list','wage_order']
    }
  },
  {
    path: '/v2/service-process/bill/detail',
    name: '账单明细',
    component: () => import ( /* webpackChunkName: "table" */ `@/views/v2/service-process/bill/detail.vue`),
    meta: {
      permission: ['set_fwlc_bill_list','wage_order']
    }
  },
  {
    path: '/v2/service-process/invoice',
    name: '发票列表',
    component: () => import ( /* webpackChunkName: "table" */ `@/views/v2/service-process/invoice/index.vue`),
    meta: {
      permission: ['set_fwlc_invoice_list','wage_order']
    }
  },
  {
    path: '/v2/service-process/bill/detail/cost-form',
    name: '账单明细-成本表单',
    component: () => import ( /* webpackChunkName: "table" */ `@/views/v2/service-process/bill/cost-forms.vue`),
    meta: {
      permission: ['set_fwlc_bill_list','wage_order']
    }
  },
]
